import React from 'react'

const MapButton = ({ activeTab, comData }) => {
    return (
        <div
            className={`tab-button ${activeTab === "map" ? "active" : ""
                }`}
            onClick={() => {
                window.open(comData?.map_url, "_blank");
            }}
            style={{
                backgroundColor: "white",
                opacity: !comData?.map_url ? 0.5 : 1,
                pointerEvents: !comData?.map_url ? "none" : "auto",
            }}
        >
            <span className="map-icon-svg">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="38"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#f54242"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M12 2c3.87 0 7 3.13 7 7 0 5.25-7 12-7 12S5 14.25 5 9c0-3.87 3.13-7 7-7z" />

                    <circle cx="12" cy="9" r="2" />
                </svg>
            </span>
            <span>Map</span>
        </div>
    )
}

export default MapButton